// apiUtils.ts

export async function fetchData(url: string, method: string, data?: any) {
  const csrfToken = document.head.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

  const headers = new Headers({
    'Content-Type': 'application/json',
  });

  if (csrfToken !== null) {
    headers.append('X-CSRF-TOKEN', csrfToken || '');
  }

  const options: RequestInit = {
    method,
    headers,
    credentials: 'same-origin', // Include credentials when making requests to the same origin
  };

  if (data) {
    options.body = JSON.stringify(data);
  }

  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Fetch request failed:", error);
    return null;
  }
}
